import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { woonsocketConfig } from "./data";

export default function WoonsocketPage() {
  return <CityPageTemplate config={woonsocketConfig} />;
}